import { useEffect } from 'react'
import { App as AntApp, ConfigProvider } from 'antd'
import enUS from 'antd/locale/en_US'
import type { ReactNode } from 'react'
import { getAntdTheme } from '@/config/antd-theme'
import { useUIStore } from '@/stores/ui.store'

/**
 * Wires Ant Design's theme + locale to the UI store and mirrors the
 * theme mode onto <html data-theme> so custom SCSS variables follow.
 * `AntApp` enables static message/notification/Modal APIs.
 */
export function AntdConfigProvider({ children }: { children: ReactNode }) {
  const themeMode = useUIStore((s) => s.themeMode)

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', themeMode)
  }, [themeMode])

  return (
    <ConfigProvider theme={getAntdTheme(themeMode)} locale={enUS}>
      <AntApp>{children}</AntApp>
    </ConfigProvider>
  )
}
